import Moment from "moment";

export const QUARTER_PRESETS = [
	{ id: "all", label: "Semua" },
	{ id: "q1", label: "Q1", quarter: 1 },
	{ id: "q2", label: "Q2", quarter: 2 },
	{ id: "q3", label: "Q3", quarter: 3 },
	{ id: "q4", label: "Q4", quarter: 4 },
	{ id: "custom", label: "Custom" },
];

export const getQuarterRange = (year, quarter) => {
	const startMonth = (quarter - 1) * 3;
	const start = Moment({ year, month: startMonth, day: 1 }).startOf("day");
	const end = start.clone().add(2, "months").endOf("month").startOf("day");

	return {
		startDate: start.toDate(),
		endDate: end.toDate(),
		start_date: start.format("YYYY-MM-DD"),
		end_date: end.format("YYYY-MM-DD"),
	};
};

export const formatDateParam = (value) => {
	if (!value) return null;
	const parsed = Moment(value);
	return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
};

export const formatDisplayRange = (startDate, endDate) => {
	if (!startDate && !endDate) return "Semua periode";

	const start = startDate
		? Moment(startDate).locale("id").format("DD MMM YYYY")
		: "…";
	const end = endDate
		? Moment(endDate).locale("id").format("DD MMM YYYY")
		: "…";

	return `${start} – ${end}`;
};

export const buildYearOptions = (yearsBack = 3) => {
	const currentYear = Moment().year();
	return Array.from({ length: yearsBack + 1 }, (_, index) => currentYear - index);
};

export const toApiDateFilters = ({ startDate, endDate } = {}) => {
	const start_date = formatDateParam(startDate);
	const end_date = formatDateParam(endDate);

	return {
		...(start_date ? { "filter[start_date]": start_date } : {}),
		...(end_date ? { "filter[end_date]": end_date } : {}),
	};
};
